import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
export const ViewTitle = props => {
    const classes = useStyles();
    return (React.createElement("div", { className: classes.root },
        React.createElement(Typography, Object.assign({ id: "react-admin-title", variant: "h5", component: "h2", color: "inherit", className: classes.title }, props))));
};
const useStyles = makeStyles(theme => ({
    root: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(),
    },
    title: {
        fontWeight: theme.typography.fontWeightMedium,
        color: theme.palette.getContrastText(theme.palette.background.default),
    },
}), {
    name: 'Layer7ViewTitle',
});
//# sourceMappingURL=ViewTitle.js.map